import { formattedTime } from "../../components/formatted/FormattedDateAndTime";

const STEP_MINUTES = 15;
const HOURS_BACK = 4;

export const buildRemovalTimeOptions = (referenceDate = new Date()) => {
  const end = new Date(referenceDate);
  const start = new Date(referenceDate);
  start.setTime(start.getTime() - HOURS_BACK * 60 * 60 * 1000);
  start.setSeconds(0, 0);
  start.setMinutes(
    Math.floor(start.getMinutes() / STEP_MINUTES) * STEP_MINUTES,
  );

  const options = [];
  const seen = new Set();

  for (
    let cursor = start.getTime();
    cursor <= end.getTime();
    cursor += STEP_MINUTES * 60 * 1000
  ) {
    const slotDate = new Date(cursor);
    const value = formattedTime(slotDate.toISOString());

    if (seen.has(value)) {
      continue;
    }

    seen.add(value);
    options.push({ value, label: value });
  }

  const nowValue = formattedTime(end.toISOString());
  if (!seen.has(nowValue)) {
    options.push({ value: nowValue, label: nowValue });
  }

  return options.reverse();
};
